export default {
  zh: {
    columns: {
      dName: 'Dashboard名称',
      name: '报告名称',
      type: '报告类型',
      createdAt: '创建时间',
      createdBy: '创建者',
      lastModifiedBy: '最后更新时间'
    },
    newReport: '新报告',
    newDashboard: '新Dashboard',
    chooseType: '选择报告类型',
    sharedTo: '分享给'
  },
  en: {
    columns: {
      dName: 'Dashboard Name',
      name: 'Report Name',
      type: 'Report Type',
      createdAt: 'Date Created',
      createdBy: 'Created By',
      lastModifiedBy: 'Last Modified By'
    },
    newReport: 'New Report',
    newDashboard: 'New Dashboard',
    chooseType: 'Choose A Report Type',
    sharedTo: 'Shared To'
  }
};



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/i18n.js